import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { UserSearchResult } from '../../types/search';
import { FramedAvatar } from '../ui/FramedAvatar';

interface UserSearchCardProps {
  user: UserSearchResult;
  searchState?: {
    query: string;
    activeTab: string;
    results: any[];
  };
}

export const UserSearchCard: React.FC<UserSearchCardProps> = ({ user, searchState }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleUserClick = () => {
    // Usar searchState da prop se disponível, senão usar location.state
    const currentSearchState = searchState || location.state?.searchState || {
      query: '',
      activeTab: 'all',
      results: []
    };

    navigate(`/profile/${user.username}`, {
      state: { searchState: currentSearchState }
    });
  };

  return (
    <div
      onClick={handleUserClick}
      className="flex items-center justify-between py-2 bg-transparent rounded-lg hover:bg-white/10 transition-colors duration-200 cursor-pointer"
    >
      <div className="flex items-center space-x-4">
        <FramedAvatar
          beltRank={user.belt_rank || 'blue'}
          initials={user.full_name.split(' ').map(n => n[0]).join('').slice(0,2)}
          alt={user.full_name}
          frameSize={{ w: 38, h: 40 }}
        />
        <div>
          <h3 className="font-medium text-white font-roboto text-sm">{user.full_name}</h3>
          <p className="text-white/60 text-xs font-roboto">@{user.username}</p>
          {user.academy_name && (
            <p className="text-white/40 text-xs font-roboto">{user.academy_name}</p>
          )}
        </div>
      </div>
    </div>
  );
}; 